import { Typography, Button, Grid } from "@mui/material";
import { useSlideInContext } from "ui";
import { SELECT_TOUR_STEP } from "..";

type USER_GUIDE_DESTINATION = "QuickStart" | "UserManual" | "SampleReport" | "VideoTutorial" | "TriageReport" | "TScreenVideo" | "TweenScreenVideo";

export default function UserGuide() {
    const { handleContent } = useSlideInContext()
    const handleClick = (destination: USER_GUIDE_DESTINATION) => {
        switch (destination) {

            case "QuickStart":
                window.open("https://docs.google.com/document/d/1UQdbR9AJ_LEfI-v7-bFw-8XmVdx6mAL4S18ODly5R4w/edit?usp=sharing");
                break;
            case "UserManual":
                window.open("https://docs.google.com/document/d/1gQhOsI1IVe6TEQ5e2BIRdV2g8-8OjQEK_B2wq9aurvM/edit?usp=sharing");
                break;
            case "TScreenVideo":
                window.open("https://drive.google.com/file/d/1kO3eR5HOI0b3wnWLJvzG0n10Lnx4LZfJ/view?usp=sharing")
                break;
            case "TweenScreenVideo":
                window.open("https://drive.google.com/file/d/1AS2sMUdlzxOFeEJXoVHvvYPrxScZsT-p/view?usp=sharing")
                break;
            // case "VideoTutorial":
            //     window.open("https://drive.google.com/file/d/1Bm0lAlMtNju7qsJ3sbRb5P4nM4p87O-g/view?usp=sharing");
            //     break;
            case "TriageReport":
                window.open("https://drive.google.com/file/d/11CeIP5PTqJv8RI63GVrUVsHTO8eFDTPY/view?usp=sharing")
                // handleContent(SELECT_TOUR_STEP)
                break;
            case "SampleReport":
                window.open("https://drive.google.com/file/d/1w1Js-ZPujBNgkJg3QZFbfAhfCnXBn9et/view?usp=sharing")
                break;
            default:
                break;
        }
    }
    return (
        <Grid container spacing={2} direction="column" alignItems={"center"}
            sx={{ padding: "36px 16px", textAlign: "center" }}>
            <Grid size={12} direction={"column"} alignItems={"center"}>
                <Button variant="contained" onClick={() => handleClick("UserManual")}>User Manual</Button>
            </Grid>
            <Grid size={12} direction={"column"} alignItems={"center"}>
                <Button variant="contained" onClick={() => handleClick("QuickStart")}>Quick Start</Button>
            </Grid>
            <Grid size={12} direction={"column"} alignItems={"center"}>
                <Button variant="contained" onClick={() => handleClick("TriageReport")}>Triage Explained </Button>
            </Grid>
            <Grid size={12} direction={"column"} alignItems={"center"}>
                <Button variant="contained" onClick={() => handleClick("SampleReport")}>Sample Report </Button>
            </Grid>
            {/* <Grid size={12} direction={"column"} alignItems={"center"}>
                <Typography>Video tutorial for the most commonly used functions</Typography>
                <Button variant="contained" onClick={() => handleClick("VideoTutorial")}>Video Tutorial</Button>
            </Grid> */}
            <Grid size={12} direction={"column"} alignItems={"center"}>
                <Typography>Sample video for Parental Consent</Typography>
                <Grid container>
                    <Grid size={6}>
                        <Button variant="contained" onClick={() => handleClick("TScreenVideo")}>TScreen</Button>
                    </Grid>
                    <Grid size={6}>
                        <Button variant="contained" onClick={() => handleClick("TweenScreenVideo")}>TweenScreen</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid >
    )
}